// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Bulle_tooltip__3q_RK {\n  padding: 10px;\n  font-size: 0.8rem;\n  text-align: center;\n}\n", "",{"version":3,"sources":["webpack://src/Components/Includes/Wrapper/Bulle.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":[".tooltip {\n  padding: 10px;\n  font-size: 0.8rem;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltip": "Bulle_tooltip__3q_RK"
};
export default ___CSS_LOADER_EXPORT___;
